<div class="container mt-30">
  <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="1" />
</div>
